// import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useQuery } from '@tanstack/react-query';
import { fetchDashboardData, DashboardResponse } from '@/api/dashboard';
import BackgroundVideo from '@/components/BackgroundVideo';
import ArrowDropdownIcon from '@/assets/mo/arrow-dropdown.svg?react';
// import PcInquiry from '@/components/pc/Inquiry';
import PcAssignSection from './AssignSection';
import PcVerification from './Verification';
import ReviewSection from './ReviewListSection';
// import { Helmet } from 'react-helmet-async';

const PcMain = () => {
  const { data, isPending } = useQuery<DashboardResponse>({
    queryKey: ['dashboardData'],
    queryFn: fetchDashboardData,
  });

  return (
    <>
      {/* <Helmet>
        <title>올받음</title>
        <meta
          name="description"
          content="손해사정사 선임권 분야 1위! 사망보험금, 후유장해, 진단금, 배상책임, 무료선임 등 어렵고 복잡한 보험금 분쟁, 전문가에게 맡기세요"
        />
        <meta property="og:title" content="올받음" />
        <meta
          property="og:description"
          content="손해사정사 선임권 분야 1위! 사망보험금, 후유장해, 진단금, 배상책임, 무료선임 등 어렵고 복잡한 보험금 분쟁, 전문가에게 맡기세요"
        />
      </Helmet>{' '} */}
      <Wrapper>
        <BackgroundVideo />
        <Content>
          <Title>지금 이 순간에도 수많은 사람들이 보험금을 받고 있습니다</Title>
          <SubTitle>
            대한민국 NO.1 올받음 <br />
            복잡한 절차와 숨겨진 보상 기준, 전문가와 함께라면 다릅니다
          </SubTitle>

          <StatsWrapper>
            <StatBlock>
              <StatLabel>누적 선임 수 통계</StatLabel>
              <StatContent>
                <StatNumber>
                  {' '}
                  {isPending ? '...' : `${data?.totalUserCount?.toLocaleString()}`}
                </StatNumber>
                <ArrowDropdownIcon style={{ width: '48px', height: '48px' }} />
              </StatContent>
            </StatBlock>

            <StatBlock>
              <StatLabel>누적 선임 상담 수</StatLabel>
              <StatContent>
                <StatNumber>
                  {' '}
                  {isPending ? '...' : `${data?.customerScore?.toLocaleString()}`}
                </StatNumber>
                <ArrowDropdownIcon style={{ width: '48px', height: '48px' }} />
              </StatContent>
            </StatBlock>

            <StatBlock>
              <StatLabel>선임 가능 지역</StatLabel>
              <StatContent>
                <StatNumber>전국</StatNumber>
                <ArrowDropdownIcon style={{ width: '48px', height: '48px' }} />
              </StatContent>
            </StatBlock>
          </StatsWrapper>
        </Content>
      </Wrapper>
      <AssignWrapper>
        {/* <PcInquiry /> */}
        <ReviewSection />
        <PcAssignSection />
        <PcVerification />
      </AssignWrapper>
    </>
  );
};

export default PcMain;

// 스타일 정의
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 80px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 91px;
  padding: 64px 0px 8px 0px;
`;

const Title = styled.h1`
  color: var(--gray-ui_gray01, #191919);
  text-align: center;
  font-size: 54px;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -1.08px;
`;

const SubTitle = styled.p`
  padding-top: 16px;
  color: var(--gray-ui_gray03, #3a3a3a);
  text-align: center;
  font-size: 26px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.52px;
`;

const StatsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
  align-items: center;

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`;

const StatBlock = styled.div`
  width: 100%;
  max-width: 394px;
  aspect-ratio: 394 / 236;

  padding: 34px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  border-radius: 32px;
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 12.8px 25.6px 64px 0px rgba(0, 0, 0, 0.06);
  backdrop-filter: blur(10px);

  @media (max-width: 1023px) {
    width: 100%; // 부모가 column일 때 전체 너비
  }
`;

const StatLabel = styled.div`
  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 18px;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.36px;
`;

const StatContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const StatNumber = styled.div`
  color: var(--Primary-darkgray, #000c24);
  font-size: 56px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: 1.12px;
`;

const AssignWrapper = styled.div`
  width: 100%;
  margin-top: 48px;
  background: #fff;
`;
